<template>
  <div>
    <step :navItems="navItems" :index="1" :step="step" v-on:step="updateStep" v-on:back="() => { this.$router.push('/course-mgr') }">
      <template slot="header">
        <h3>{{$t('attachment_list')}}</h3>
      </template>

      <template slot="body">
        <div class="row mt-3">
          <div class="col-8 offset-2">
            <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" v-show="false" />

            <ul class="list-group list-group-flush">
              <li class="list-group-item border text-left mb-3"
                style="line-height: 150%; cursor: pointer;"
                @click="$refs.file.click()"
                v-if="file === null">
                <div class="float-left">
                  {{$t('upload_tips')}}<br />
                  {{$t('upload_rules')}}
                </div>
              </li>

              <li class="list-group-item border text-left mb-3"
                style="line-height: 150%;"
                v-else>
                <div class="float-left">
                  {{ file.name }}<br />{{ Math.round(file.size * 1000 / 1024 / 1024) / 1000 }} MB
                </div>

                <div class="float-right">
                  <icon-button name="upload" :alt="$t('upload_progress')" @click.native="upload()" />
                </div>
              </li>

              <li class="list-group-item text-left mb-3 border-0 clearfix pt-4"  v-if="progress > -1">
                <div class="float-left">{{$t('upload_progress')}}：</div>
                <div class="progress mt-2" style="height: 0.2rem;">
                  <div class="progress-bar progress-bar-danger progress-bar-striped active"
                    role="progressbar"
                    :aria-valuenow="progress"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    v-bind:style="{ width: progress + '%', 'border-width': '1px', 'background-color': '#5dceb0' }">
                    <span class="sr-only">{{ progress }}% {{ $t('_finish') }}</span>
                  </div>
                </div>
                <icon-button name="cancelUpload" style="position: absolute; top: 0; right: 0;" @click.native="cancelUpload()" />
              </li>

              <li class="list-group-item border text-left mb-3"
                style="line-height: 150%;"
                v-for="item in list"
                :key="item.id">
                <div class="float-left">
                  {{ item.name }}<br />{{ Math.round(item.fileSize * 1000 / 1024 / 1024) / 1000 }} MB
                </div>

                <span class="float-right">
                  <icon-button name="download" :alt="$t('_download')" @click.native="getAttachment(item.id)" />
                  <icon-button name="delete" :alt="$('delete')" @click.native="remove(item.id)" />
                </span>
              </li>
            </ul>

            <pagination class="mt-3" :current="pageIndex" :total="pageCount" v-on:page="updatePage" />
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="2" :step="step" v-on:step="updateStep" v-on:finish="() => { this.$router.push('/course-mgr') }">
      <template slot="header">
        <h3>{{ $t('_finish') }}</h3>
      </template>
    </step>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Step from './Step'
import api from '../../store/api'
import Pagination from '../../components/Pagination'
import IconButton from './IconButton'
import axios from 'axios'
import swal from 'bootstrap-sweetalert'

export default {

  name: 'TeachingCourseAttachment',

  components: {
    Step,
    Pagination,
    IconButton
  },

  data () {
    return {
      navItems: [this.$t('add_or_select_list'), this.$t('please_choose_a_file'), this.$t('_finish')],
      step: 1,
      courseId: null,
      list: [],
      pageIndex: 1,
      pageCount: 0,
      file: null,
      progress: -1,
      source: null
    }
  },

  mounted () {
    this.courseId = this.$route.params.courseId
    this.getAttachment()
  },

  methods: {
    ...mapActions([
      'getAttachment'
    ]),

    async getAttachment (page) {
      let params = {
        pageIndex: page || 1,
        pageSize: 10
      }

      const { data } = await api.get('/CourseMgr/TeachingCourse/' + this.courseId + '/Attacheds', { params: params })

      if (data.status === 'OK') {
        this.list = data.data
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    },

    updateStep (step) {
      this.step = step
    },

    updatePage (page) {
      this.getAttachment(page)
    },

    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      console.log(this.file)
    },

    async upload () {
      const CancelToken = axios.CancelToken
      this.source = CancelToken.source()

      let formData = new window.FormData()
      formData.append('file', this.file)

      this.progress = 0

      const { data } = await api.post('/CourseMgr/TeachingCourse/' + this.courseId + '/Attacheds', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        cancelToken: this.source.token,
        onUploadProgress: this.uploadProgress
      })

      if (data.status === 'OK') {
        this.file = null
        this.progress = -1
        console.log('complete', data.data)

        this.list.push(data.data)
      }
    },

    cancelUpload () {
      this.source.cancel('Operation canceled by the user.')
      console.log('canceled')
      this.progress = -1
    },

    uploadProgress (oEvent) {
      let self = this

      if (oEvent.lengthComputable) {
        let percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total)
        self.progress = percentComplete
      } else {
        // Unable to compute progress information since the total size is unknown
        self.progress = -1
      }
    },

    remove (id) {
      let self = this
      swal({
        title: this.$t('deleting_confirm'),
        text: this.$t('note'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.$t('want_delete'),
        cancelButtonText: this.$t('cancel'),
        closeOnConfirm: false
      },
      async function () {
        const { data } = await api.delete('/CourseMgr/TeachingCourse/Attacheds/' + id)

        if (data.status === 'OK') {
          console.log('delete complete', data)
          let idx = self.list.map((el) => { return el.id }).indexOf(id)

          if (idx > -1) {
            self.list.splice(idx, 1)
          }

          swal(this.$t('successfully_deleted'), this.$t('Unassigned'), 'success')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// TeachingCourseAttachment.vue?3dcc3530